/**
 * Saleor liefert leere Alt-Texte als "" (`ProductMedia.alt` ist `String!`, `Image.alt` eines
 * Produkt-Thumbnails trägt den leeren Medien-Alt), deshalb greift `??` nicht.
 * Leere und reine Leerzeichen-Alts gelten als fehlend.
 */
export function resolveImageAlt(alt: string | null | undefined, fallback: string): string {
	const trimmed = typeof alt === "string" ? alt.trim() : "";
	return trimmed.length > 0 ? trimmed : fallback.trim();
}
